import {WlDropDownButtons} from "./dropdownButtons.component";

export * from './dropdownButtons.component';
export default WlDropDownButtons;

customElements.define('wl-dropdown-buttons', WlDropDownButtons);